export default __webpack_public_path__ + "static/media/jorsh.e9639e0b.png";